import { InjectionToken } from '@angular/core';
import { WebSpeechDictationEngine } from './web-speech-dictation-engine';

// US 35405: speech-to-text for typed Ask Ryn prompts. The engine is swappable
// (browser Web Speech today, a server engine such as Azure Speech later) by
// providing DICTATION_ENGINE; nothing else changes.

export type DictationError =
  'denied' | 'no-microphone' | 'no-speech' | 'failed';

export interface DictationHandlers {
  // The whole text heard this session, final and interim parts joined.
  text(transcript: string): void;
  error(code: DictationError): void;
  // Recognition stopped, by stop(), an error, or the engine itself.
  ended(): void;
}

export interface DictationSession {
  // Stop listening and keep what was heard.
  stop(): void;
}

export interface DictationEngine {
  readonly supported: boolean;
  start(handlers: DictationHandlers): DictationSession;
}

export const DICTATION_ENGINE = new InjectionToken<DictationEngine>(
  'DICTATION_ENGINE',
  { providedIn: 'root', factory: () => new WebSpeechDictationEngine() }
);

// Append dictated text to what was already in the prompt.
export function appendDictation(prefix: string, dictated: string): string {
  const head = prefix.trimEnd();
  const tail = dictated.trim();
  if (!tail) return prefix;
  return head ? `${head} ${tail}` : tail;
}
